const SELECTED_LOCATIONS_KEY = 'bulkEditLocations';

/**
 * Read the bulk-edit location selection persisted for this tab.
 * Persists in sessionStorage (survives a reload, clears on tab close).
 *
 * @return {string[]}
 */
export function readSelectedLocations(): string[] {
	try {
		const raw: string | null = sessionStorage.getItem(SELECTED_LOCATIONS_KEY);
		const parsed: unknown = raw ? JSON.parse(raw) : null;

		if (!Array.isArray(parsed)) {
			return [];
		}

		return parsed.filter((id: unknown): id is string => typeof id === 'string' && !!id);
	}
	catch {
		return [];
	}
}

/**
 * Persist the bulk-edit location selection for this tab.
 *
 * @param {string[]} locationIds
 * @return {void}
 */
export function writeSelectedLocations(locationIds: string[]): void {
	try {
		sessionStorage.setItem(SELECTED_LOCATIONS_KEY, JSON.stringify(locationIds));
	}
	catch {
		// Quota or private-mode failures are non-fatal: the selection still lives in the store for this
		// navigation, only reload-survival is lost.
	}
}
